import { TslDebug } from '@/components/TslDebug';
import TslDebugArea from '@/components/TslDebugArea';
import WebGpuCanvas from '@/components/WebGpuCanvas';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { float, Fn, positionLocal, vec3, length, max, sin, fract, time, abs, pow } from 'three/tsl';

export type Props = {};

const fragmentNode = Fn(() => {
  const p = positionLocal.toVar();
  p.mulAssign(5);
  const radius = float(0.1);
  const intensity = 2;

  const colours = [vec3(1.0, 0.05, 0.3), vec3(0.1, 0.4, 1.0), vec3(0.2, 1.0, 0.2)];

  const finaleColor = vec3(0.0, 0.0, 0.0);

  for (let i = 0; i < colours.length; i++) {
    p.mulAssign(sin(i).add(0.5));
    p.assign(fract(p).sub(0.5));
    const distance = length(p);

    distance.assign(sin(distance.mul(10).sub(time)));
    distance.assign(abs(distance));

    distance.assign(pow(radius.div(distance), intensity));

    const col = colours[i];
    finaleColor.assign(max(finaleColor, col.mul(distance)));
  }

  // return positionLocal;
  return finaleColor;
});

function App01(props: Props) {
  const {} = props;

  return (
    <>
      <TslDebugArea style={{ backgroundColor: 'black' }}>
        {(el) => (
          <WebGpuCanvas>
            <PerspectiveCamera
              makeDefault
              fov={53}
              aspect={el.clientWidth / el.clientHeight}
              near={0.1}
              far={10}
              position={[0, 0, 1]}
            />
            <mesh name="node-mesh">
              <planeGeometry args={[5, 5]} />
              <nodeMaterial key={Date.now()} fragmentNode={fragmentNode()} />
              <TslDebug meshName={'node-mesh'} />
            </mesh>
            <gridHelper rotation={[-Math.PI / 2, 0, 0]} />
            <axesHelper />
            <OrbitControls />
          </WebGpuCanvas>
        )}
      </TslDebugArea>
    </>
  );
}

export default App01;
